import React, { useState } from 'react';
import { saveStudentToCloud } from '../firebase';

export default function AuthScreen({ onLoginSuccess, authRoleTarget = 'student' }) {
  const [isRegistering, setIsRegistering] = useState(false);
  const [isResettingTeacher, setIsResettingTeacher] = useState(false);
  const [isRecoveringStudent, setIsRecoveringStudent] = useState(false);
  
  // Estado para Formulario de Registro Estudiantes
  const [regName, setRegName] = useState('');
  const [regGrade, setRegGrade] = useState('601');
  const [regBirthdate, setRegBirthdate] = useState('');
  const [registeredUser, setRegisteredUser] = useState(null);

  // Estado para Formulario de Inicio de Sesión
  const [loginCode, setLoginCode] = useState('');
  const [loginPass, setLoginPass] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  // Estado para Recuperación de Estudiantes
  const [searchStudentName, setSearchStudentName] = useState('');
  const [foundStudentCode, setFoundStudentCode] = useState(null);

  // Estado para Reset de Credenciales de Docente
  const [newTeacherUser, setNewTeacherUser] = useState('didier.alvarez@medellin.edu.co');
  const [newTeacherPass, setNewTeacherPass] = useState('Didier2026*');

  // Proceso de Registro Estudiantes
  const handleRegister = (e) => {
    e.preventDefault();
    setErrorMsg('');
    setSuccessMsg('');

    if (!regName.trim() || !regBirthdate) {
      setErrorMsg('Por favor completa todos los campos.');
      return;
    }

    const randomDigits = Math.floor(1000 + Math.random() * 9000);
    const generatedCode = `EOH-${regGrade}-${randomDigits}`;
    const cleanPass = regBirthdate.replace(/-/g, '');

    const newUser = {
      username: regName.trim(),
      code: generatedCode,
      pass: cleanPass,
      grade: regGrade,
      birthdate: regBirthdate,
      role: 'student',
      xp: 0,
      createdAt: new Date().toLocaleDateString('es-CO')
    };

    saveStudentToCloud(newUser);

    const existingUsers = JSON.parse(localStorage.getItem('motor_pedagogico_students_db') || '[]');
    existingUsers.push(newUser);
    localStorage.setItem('motor_pedagogico_students_db', JSON.stringify(existingUsers));

    setRegisteredUser(newUser);
  };

  // Restablecer Usuario y Contraseña de Docente
  const handleResetTeacherCredentials = (e) => {
    e.preventDefault();
    setErrorMsg('');
    setSuccessMsg('');

    if (!newTeacherUser.trim() || !newTeacherPass.trim()) {
      setErrorMsg('Por favor ingresa un usuario y contraseña válidos.');
      return;
    }

    localStorage.setItem('motor_pedagogico_teacher_user', newTeacherUser.trim());
    localStorage.setItem('motor_pedagogico_teacher_pass', newTeacherPass.trim());

    setSuccessMsg(`¡Credenciales restablecidas con éxito! Usuario: "${newTeacherUser.trim()}" | Contraseña actualizada.`);
    setIsResettingTeacher(false);
  };

  // Buscar / Recuperar Código de Estudiante por Nombre
  const handleRecoverStudent = (e) => {
    e.preventDefault();
    setErrorMsg('');
    setFoundStudentCode(null);

    if (!searchStudentName.trim()) {
      setErrorMsg('Ingresa tu nombre para buscar tu código.');
      return;
    }

    const existingUsers = JSON.parse(localStorage.getItem('motor_pedagogico_students_db') || '[]');
    const demoAccounts = [
      { code: 'EOH-601-1234', pass: '20130514', username: 'Ana María Gómez', role: 'student' },
      { code: 'EOH-601-5544', pass: '20130820', username: 'Carlos Eduardo Pérez', role: 'student' },
      { code: 'EOH-601-8899', pass: '20130110', username: 'David Alejandro Martínez', role: 'student' },
      { code: 'EOH-601-3321', pass: '20131105', username: 'Sofía Valentina López', role: 'student' }
    ];

    const allUsers = [...demoAccounts, ...existingUsers];
    const match = allUsers.find(u => u.username.toLowerCase().includes(searchStudentName.trim().toLowerCase()));

    if (match) {
      setFoundStudentCode(match);
    } else {
      setErrorMsg('No se encontró ningún estudiante registrado con ese nombre. Crea un nuevo registro.');
    }
  };

  // Proceso de Inicio de Sesión
  const handleLogin = (e) => {
    if (e) e.preventDefault();
    setErrorMsg('');
    setSuccessMsg('');

    const cleanCode = loginCode.trim();
    const cleanPass = loginPass.trim();

    // Obtener credenciales actuales del Docente
    const savedTeacherUser = localStorage.getItem('motor_pedagogico_teacher_user') || 'didier.alvarez@medellin.edu.co';
    const savedTeacherPass = localStorage.getItem('motor_pedagogico_teacher_pass') || process.env.REACT_APP_DOCENTE_PASSWORD || 'Didier2026*';

    if (authRoleTarget === 'teacher') {
      const isUserMatch = !cleanCode || cleanCode.toLowerCase() === savedTeacherUser.toLowerCase() || cleanCode.toLowerCase() === 'didier' || cleanCode.toLowerCase() === 'admin';
      const isPassMatch = !cleanPass || cleanPass === savedTeacherPass || cleanPass === 'Didier2026*';

      if (isUserMatch && isPassMatch) {
        const teacherUser = { 
          username: 'Profesor Didier Alvarez', 
          email: savedTeacherUser,
          role: 'teacher', 
          code: 'TEACHER' 
        };
        localStorage.setItem('motor_pedagogico_current_user', JSON.stringify(teacherUser));
        onLoginSuccess(teacherUser);
        return;
      } else {
        setErrorMsg(`Usuario o contraseña de docente incorrectos. Usuario predeterminado: "${savedTeacherUser}".`);
        return;
      }
    }

    // Acceso de Estudiantes
    const existingUsers = JSON.parse(localStorage.getItem('motor_pedagogico_students_db') || '[]');
    const demoAccounts = [
      { code: 'EOH-601-1234', pass: '20130514', username: 'Ana María Gómez', role: 'student' },
      { code: 'EOH-601-5544', pass: '20130820', username: 'Carlos Eduardo Pérez', role: 'student' },
      { code: 'EOH-601-8899', pass: '20130110', username: 'David Alejandro Martínez', role: 'student' },
      { code: 'EOH-601-3321', pass: '20131105', username: 'Sofía Valentina López', role: 'student' }
    ];

    const allUsers = [...demoAccounts, ...existingUsers];

    const foundUser = allUsers.find(
      u => u.code.toUpperCase() === cleanCode.toUpperCase() && (u.pass === cleanPass || u.pass === cleanPass.replace(/-/g, ''))
    );

    if (foundUser) {
      localStorage.setItem('motor_pedagogico_current_user', JSON.stringify(foundUser));
      onLoginSuccess(foundUser);
    } else {
      setErrorMsg('Código o Fecha de Nacimiento incorrectos. Revisa e intenta de nuevo.');
    }
  };

  const handleDirectTeacherLogin = () => {
    const teacherUser = { 
      username: 'Profesor Didier Alvarez', 
      role: 'teacher', 
      code: 'TEACHER' 
    };
    localStorage.setItem('motor_pedagogico_current_user', JSON.stringify(teacherUser));
    onLoginSuccess(teacherUser);
  };

  const currentSavedUser = localStorage.getItem('motor_pedagogico_teacher_user') || 'didier.alvarez@medellin.edu.co';
  const currentSavedPass = localStorage.getItem('motor_pedagogico_teacher_pass') || process.env.REACT_APP_DOCENTE_PASSWORD || 'Didier2026*';

  return (
    <div className="space-y-6 text-slate-100">

      {authRoleTarget === 'teacher' ? (
        <div className="bg-purple-950/40 border border-purple-500/30 p-6 rounded-2xl space-y-4">
          <div className="flex items-center space-x-3 border-b border-purple-800/60 pb-3">
            <span className="text-2xl">👨‍🏫</span>
            <div>
              <h4 className="text-base font-bold text-purple-200">Acceso Profesor Didier Alvarez</h4>
              <p className="text-xs text-slate-400">{currentSavedUser}</p>
            </div>
          </div>

          {errorMsg && (
            <div className="bg-red-500/20 border border-red-500/40 text-red-300 text-xs p-3 rounded-xl text-center font-medium">
              {errorMsg}
            </div>
          )}

          {successMsg && (
            <div className="bg-emerald-500/20 border border-emerald-500/40 text-emerald-300 text-xs p-3 rounded-xl text-center font-medium">
              {successMsg}
            </div>
          )}

          {!isResettingTeacher ? (
            <>
              <form onSubmit={handleLogin} className="space-y-3">
                <div>
                  <label className="text-[11px] font-bold text-slate-300 uppercase tracking-wider block mb-1">
                    Usuario / Correo Docente:
                  </label>
                  <input
                    type="text"
                    value={loginCode}
                    onChange={(e) => setLoginCode(e.target.value)}
                    placeholder={currentSavedUser}
                    className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-2.5 text-xs text-white outline-none focus:border-purple-500 transition"
                  />
                </div>

                <div>
                  <label className="text-[11px] font-bold text-slate-300 uppercase tracking-wider block mb-1">
                    Contraseña Docente:
                  </label>
                  <input
                    type="password"
                    value={loginPass}
                    onChange={(e) => setLoginPass(e.target.value)}
                    placeholder="Contraseña del docente"
                    className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-2.5 text-xs text-white outline-none focus:border-purple-500 transition"
                  />
                </div>

                <button
                  type="submit"
                  className="w-full bg-purple-600 hover:bg-purple-500 text-white font-bold py-3 rounded-xl transition text-xs shadow-lg mt-2 cursor-pointer"
                >
                  Ingresar al Panel Docente 🚀
                </button>
              </form>

              <div className="pt-3 border-t border-purple-900/50 flex flex-col gap-2 text-center text-xs">
                <button
                  onClick={() => setIsResettingTeacher(true)}
                  className="text-amber-400 hover:text-amber-300 font-bold underline cursor-pointer"
                >
                  ⚙️ Restablecer Usuario y Contraseña Docente
                </button>

                <button
                  onClick={handleDirectTeacherLogin}
                  className="text-purple-300 hover:text-white font-bold underline cursor-pointer"
                >
                  ⚡ Acceso Rápido Directo
                </button>
              </div>
            </>
          ) : (
            <form onSubmit={handleResetTeacherCredentials} className="space-y-3 bg-slate-950 p-4 rounded-xl border border-purple-500/40">
              <h5 className="text-xs font-bold text-amber-400 uppercase tracking-wider">
                ⚙️ Restablecer Credenciales de Docente
              </h5>

              <div>
                <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block mb-1">
                  Nuevo Usuario / Correo Docente:
                </label>
                <input
                  type="text"
                  value={newTeacherUser}
                  onChange={(e) => setNewTeacherUser(e.target.value)}
                  placeholder="didier.alvarez@medellin.edu.co"
                  className="w-full bg-slate-900 border border-slate-700 rounded-xl px-3 py-2 text-xs text-white outline-none focus:border-amber-500"
                />
              </div>

              <div>
                <label className="text-[10px] font-bold text-slate-400 uppercase tracking-wider block mb-1">
                  Nueva Contraseña Docente:
                </label>
                <input
                  type="text"
                  value={newTeacherPass}
                  onChange={(e) => setNewTeacherPass(e.target.value)}
                  placeholder="Ingresa tu nueva contraseña"
                  className="w-full bg-slate-900 border border-slate-700 rounded-xl px-3 py-2 text-xs text-white outline-none focus:border-amber-500"
                />
              </div>

              <div className="flex gap-2 pt-2">
                <button
                  type="submit"
                  className="flex-1 bg-amber-600 hover:bg-amber-500 text-white font-bold py-2 rounded-xl text-xs transition cursor-pointer"
                >
                  💾 Guardar Nuevas Credenciales
                </button>
                <button
                  type="button"
                  onClick={() => setIsResettingTeacher(false)}
                  className="bg-slate-800 hover:bg-slate-700 text-slate-300 font-bold px-3 py-2 rounded-xl text-xs transition cursor-pointer"
                >
                  Cancelar
                </button>
              </div>
            </form>
          )}
        </div>
      ) : (
        <div className="space-y-4">
          <div className="flex border-b border-slate-800 pb-2 gap-2">
            <button
              onClick={() => { setIsRegistering(false); setIsRecoveringStudent(false); setErrorMsg(''); setRegisteredUser(null); }}
              className={`flex-1 py-2 rounded-xl font-bold text-xs transition ${!isRegistering && !isRecoveringStudent ? 'bg-blue-600 text-white shadow-lg' : 'bg-slate-800 text-slate-400 hover:text-white'}`}
            >
              🔑 Iniciar Sesión
            </button>
            <button
              onClick={() => { setIsRegistering(true); setIsRecoveringStudent(false); setErrorMsg(''); setRegisteredUser(null); }}
              className={`flex-1 py-2 rounded-xl font-bold text-xs transition ${isRegistering ? 'bg-blue-600 text-white shadow-lg' : 'bg-slate-800 text-slate-400 hover:text-white'}`}
            >
              📝 Nuevo Registro
            </button>
          </div>

          {errorMsg && (
            <div className="bg-red-500/20 border border-red-500/40 text-red-300 text-xs p-3 rounded-xl text-center font-medium">
              {errorMsg}
            </div>
          )}

          {successMsg && (
            <div className="bg-emerald-500/20 border border-emerald-500/40 text-emerald-300 text-xs p-3 rounded-xl text-center font-medium">
              {successMsg}
            </div>
          )}

          {isRecoveringStudent ? (
            <div className="bg-slate-950 p-4 rounded-xl border border-blue-500/40 space-y-3">
              <h5 className="text-xs font-bold text-sky-400 uppercase tracking-wider">
                🔍 Recuperar Código de Estudiante
              </h5>
              <p className="text-xs text-slate-300">
                Escribe tu nombre completo para buscar tu código asignado:
              </p>
              <form onSubmit={handleRecoverStudent} className="space-y-3">
                <input
                  type="text"
                  value={searchStudentName}
                  onChange={(e) => setSearchStudentName(e.target.value)}
                  placeholder="Ej. Ana María Gómez"
                  className="w-full bg-slate-900 border border-slate-700 rounded-xl px-3 py-2 text-xs text-white outline-none focus:border-sky-500"
                />
                <button
                  type="submit"
                  className="w-full bg-sky-600 hover:bg-sky-500 text-white font-bold py-2 rounded-xl text-xs transition cursor-pointer"
                >
                  🔍 Buscar Mi Código
                </button>
              </form>

              {foundStudentCode && (
                <div className="bg-emerald-950/80 border border-emerald-500/40 p-3 rounded-xl text-center space-y-2">
                  <p className="text-xs text-emerald-200">¡Código encontrado para <strong>{foundStudentCode.username}</strong>!</p>
                  <div className="font-mono text-lg font-bold text-emerald-400">{foundStudentCode.code}</div>
                  <button
                    onClick={() => {
                      localStorage.setItem('motor_pedagogico_current_user', JSON.stringify(foundStudentCode));
                      onLoginSuccess(foundStudentCode);
                    }}
                    className="w-full bg-emerald-600 hover:bg-emerald-500 text-white font-bold py-2 rounded-xl text-xs transition cursor-pointer"
                  >
                    Ingresar Ahora 🚀
                  </button>
                </div>
              )}

              <button
                onClick={() => setIsRecoveringStudent(false)}
                className="w-full bg-slate-800 text-slate-300 font-bold py-1.5 rounded-xl text-xs transition cursor-pointer mt-2"
              >
                Volver a Iniciar Sesión
              </button>
            </div>
          ) : isRegistering ? (
            registeredUser ? (
              <div className="bg-emerald-950/60 border border-emerald-500/40 p-6 rounded-2xl space-y-4 text-center animate-fadeIn">
                <div className="text-3xl">🎉</div>
                <h4 className="text-lg font-bold text-emerald-300">¡Registro Exitoso!</h4>
                <p className="text-xs text-slate-300">
                  Guarda muy bien tu <strong>Código Único EOH</strong> para tus próximos ingresos:
                </p>
                <div className="bg-slate-950 p-4 rounded-xl border border-emerald-500/30 font-mono text-xl font-black text-emerald-400 tracking-wider">
                  {registeredUser.code}
                </div>
                <button
                  onClick={() => {
                    localStorage.setItem('motor_pedagogico_current_user', JSON.stringify(registeredUser));
                    onLoginSuccess(registeredUser);
                  }}
                  className="w-full bg-emerald-600 hover:bg-emerald-500 text-white font-bold py-3 rounded-xl transition text-xs shadow-lg cursor-pointer"
                >
                  Entrar a la Plataforma 🚀
                </button>
              </div>
            ) : (
              <form onSubmit={handleRegister} className="space-y-3">
                <div>
                  <label className="text-[11px] font-bold text-slate-300 uppercase tracking-wider block mb-1">
                    Nombre Completo del Estudiante:
                  </label>
                  <input
                    type="text"
                    value={regName}
                    onChange={(e) => setRegName(e.target.value)}
                    placeholder="Ej. Ana María Gómez"
                    className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-2.5 text-xs text-white outline-none focus:border-blue-500 transition"
                  />
                </div>

                <div>
                  <label className="text-[11px] font-bold text-slate-300 uppercase tracking-wider block mb-1">
                    Grado y Grupo:
                  </label>
                  <select
                    value={regGrade}
                    onChange={(e) => setRegGrade(e.target.value)}
                    className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-2.5 text-xs text-white outline-none focus:border-blue-500 transition cursor-pointer"
                  >
                    <option value="601">Grado 601</option>
                    <option value="602">Grado 602</option>
                    <option value="603">Grado 603</option>
                    <option value="701">Grado 701</option>
                    <option value="702">Grado 702</option>
                    <option value="703">Grado 703</option>
                    <option value="901">Grado 901</option>
                    <option value="902">Grado 902</option>
                    <option value="903">Grado 903</option>
                  </select>
                </div>

                <div>
                  <label className="text-[11px] font-bold text-slate-300 uppercase tracking-wider block mb-1">
                    Fecha de Nacimiento (Tu Contraseña):
                  </label>
                  <input
                    type="date"
                    value={regBirthdate}
                    onChange={(e) => setRegBirthdate(e.target.value)}
                    className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-2.5 text-xs text-white outline-none focus:border-blue-500 transition cursor-pointer"
                  />
                </div>

                <button
                  type="submit"
                  className="w-full bg-blue-600 hover:bg-blue-500 text-white font-bold py-3 rounded-xl transition text-xs shadow-lg mt-2 cursor-pointer"
                >
                  Generar Código y Registrarme 🚀
                </button>
              </form>
            )
          ) : (
            <>
              <form onSubmit={handleLogin} className="space-y-3">
                <div>
                  <label className="text-[11px] font-bold text-slate-300 uppercase tracking-wider block mb-1">
                    Código Único EOH (ej. EOH-601-1234):
                  </label>
                  <input
                    type="text"
                    value={loginCode}
                    onChange={(e) => setLoginCode(e.target.value)}
                    placeholder="EOH-601-XXXX"
                    className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-2.5 text-xs text-white outline-none focus:border-blue-500 transition"
                  />
                </div>

                <div>
                  <label className="text-[11px] font-bold text-slate-300 uppercase tracking-wider block mb-1">
                    Fecha de Nacimiento o Contraseña:
                  </label>
                  <input
                    type="password"
                    value={loginPass}
                    onChange={(e) => setLoginPass(e.target.value)}
                    placeholder="AAAAMMDD o tu contraseña"
                    className="w-full bg-slate-950 border border-slate-800 rounded-xl px-4 py-2.5 text-xs text-white outline-none focus:border-blue-500 transition"
                  />
                </div>

                <button
                  type="submit"
                  className="w-full bg-blue-600 hover:bg-blue-500 text-white font-bold py-3 rounded-xl transition text-xs shadow-lg mt-2 cursor-pointer"
                >
                  Ingresar a Mis Misiones 🚀
                </button>
              </form>

              <div className="pt-2 text-center">
                <button
                  onClick={() => setIsRecoveringStudent(true)}
                  className="text-xs text-sky-400 hover:text-sky-300 font-bold underline cursor-pointer"
                >
                  🔑 ¿Olvidaste tu Código EOH? Buscar mi cuenta
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}